import get from 'lodash.get';
export default function getCartItemVariant(cartItem) {
    const isVariant = cartItem.variant;
    const variantImage = get(cartItem, 'variant.images[0]');
    const hasVariantImage = !!variantImage;
    const variantValues = get(cartItem, 'variant.values', []);
    return { isVariant, hasVariantImage, variantImage, variantValues };
}
//# sourceMappingURL=getCartItemVariant.js.map